import React, { useRef } from "react";
import { useEffect } from "react";
import { secondsToHMS } from "../../utils/utils";
import { getTimers } from "../../utils/awsAPI";

const BreakTime = () => {
    const [isBreakEnable, setIsBreakEnable] = React.useState(false);
    const [breakTimes, setBreakTimes] = React.useState({timeAllow : 0, timeUtilised : 0, timeLeft : 0, timeExtra : 0})
    const timerRef = useRef<any>(null);
    const breakTrigger = useRef<any>("");
    const lunchTrigger = useRef<any>("");

    useEffect(() => {
        connect.agent(async (agent)=>{
            let username = agent.getConfiguration()?.username;
            let timer = await getTimers(username)
            if(timer.statusCode === 200) {
                setIsBreakEnable(true)
                localStorage.setItem("timerList", JSON.stringify(timer.body))
                timerRef.current = setInterval(() => {
                    let today = new Date().getDate();
                    let existingDate:any = localStorage.getItem("currentDate");
                    if(parseInt(existingDate) === today) {
                        getBreakAndLunchTimeData(timer?.body?.Alert)
                    } else {
                        localStorage.setItem("currentDate", today.toString())
                        localStorage.setItem("agentStateTimer", "")
                        localStorage.setItem("scheduledNextState", "")
                        localStorage.setItem("timerList","")
                        getBreakAndLunchTimeData(timer?.body?.Alert)
                    }
                }, 1000);
            } else {
                clearTimeout(timerRef.current);
            }
        })

        return () => clearTimeout(timerRef.current);
    },[])

    const getBreakAndLunchTimeData = async (alertTime:any, ) => {
        let existingValues = localStorage.getItem("agentStateTimer");
        let timerList = localStorage.getItem("timerList");
        if(existingValues && timerList && localStorage.getItem("recoveredTime") !== "0") {
            let existingData = JSON.parse(existingValues);
            let timerData = JSON.parse(timerList);
            let allowBreakTime = timerData.Break
            let allowLunchTime = timerData.Lunch
            let utilisedBreakTime =  existingData['Break'] + (existingData['Breakused']||0) || 0
            let utilisedLunchTime =  existingData['Lunch'] + (existingData['Lunchused']||0) || 0
            let leftBreakTime = ((allowBreakTime - utilisedBreakTime) <= 0) ? 0 : (allowBreakTime - utilisedBreakTime)
            let extraBreakTime = ((allowBreakTime - utilisedBreakTime) >= 0) ? 0 : (utilisedBreakTime - allowBreakTime)
            let extraLunchTime = ((allowLunchTime - utilisedLunchTime) >= 0) ? 0 : (utilisedLunchTime - allowLunchTime)

            setBreakTimes({timeAllow : allowBreakTime, timeUtilised : utilisedBreakTime, timeLeft : leftBreakTime, timeExtra : extraBreakTime})
            
            if(extraBreakTime > alertTime && breakTrigger.current === "") {
                breakTrigger.current = "trigger"
                showNotification("Break")
            } else if(extraLunchTime > alertTime && lunchTrigger.current === "") {
                lunchTrigger.current = "trigger"
                showNotification("Lunch")
            }
        }
    }

    const showNotification = (breakType:any) => {
        if (Notification.permission !== "granted") return false;
        const n = new Notification(`Your ${breakType} Time exceeded`, {body: "Click here to open the contact control panel now.", requireInteraction: true});
        n.onclick = () => { window.focus();};
        return true;
    }


    return (
        <React.Fragment>
            {isBreakEnable && 
                <div className="card call-info collapse show mt-3" id="break_time">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h6 className='m-0'>Break time</h6>
                    </div>
                    <div className="card-body">
                
                        
                        <div className="row">
                            <div className="col-md-12">
                                <ul className="break-time d-flex list-unstyled m-0 border rounded pt-2 pb-2">
                                    <li className="flex-fill text-center pe-2 ps-2 border-end">
                                        <p className="m-0">Time allocated</p>
                                        <h4 className="m-0">{secondsToHMS(breakTimes.timeAllow)}</h4>
                                        <div className="progress">
                                            <div className="progress-bar" style={{width:"100%"}}>&nbsp;</div>
                                        </div>
                                    </li>
                                    <li className="flex-fill text-center pe-2 ps-2 border-end timer-m-0">
                                        <p className="m-0">Time utilized</p>
                                        <h4 className="m-0">{secondsToHMS(breakTimes.timeUtilised)}</h4>
                                        <div className="progress">
                                            <div className="progress-bar bg-secondary" style={{width:"100%"}}>&nbsp;</div>
                                        </div>
                                    </li>
                                    <li className="flex-fill text-center pe-2 ps-2 border-end timer-m-0">
                                        <p className="m-0">Time left</p>
                                        <h4 className="m-0">{secondsToHMS(breakTimes.timeLeft)}</h4>
                                        <div className="progress">
                                            <div className="progress-bar bg-success" style={{width:"100%"}}>&nbsp;</div>
                                        </div>
                                    </li>
                                    <li className="flex-fill text-center pe-2 ps-2 timer-m-0">
                                        <p className="m-0">Extra time</p>
                                        <h4 className="m-0">{secondsToHMS(breakTimes.timeExtra)}</h4>
                                        <div className="progress">
                                            <div className="progress-bar bg-danger" style={{width:"100%"}}>&nbsp;</div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        
                    </div>
                </div>
            }
        </React.Fragment>
    )
}
export default BreakTime;